import Cookies from 'js-cookie'

export function hasLogin () {
  return getToken().hasLogin !== undefined
}

export function getToken () {
  return {
    hasLogin: Cookies.get('hasLogin')
  }
}

export function removeToken () {
  Cookies.remove('hasLogin')
}
